import { render, staticRenderFns } from "./ShowWallets.vue?vue&type=template&id=69745b76"
import script from "./ShowWallets.vue?vue&type=script&lang=js"
export * from "./ShowWallets.vue?vue&type=script&lang=js"
import style0 from "./ShowWallets.vue?vue&type=style&index=0&id=69745b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports